// extracted by mini-css-extract-plugin
export default {"topic":"Conta_topic__HYugQ","title":"Conta_title__9cnNY","top":"Conta_top__1XFxs","bottom":"Conta_bottom__JzOQF"};